import React, { type MouseEvent, useCallback } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

type Props = {
	onClear?: () => void;
};

const FooterButton = ({ onClear }: Props) => {
	const { formatMessage } = useIntl();

	const handleClick = useCallback(
		(mouseEvent: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'orderByClearSelectedItems', {
				// If number of clicks is 0, button was actioned using the keyboard
				keyboard: mouseEvent.detail === 0,
			});

			onClear && onClear();
		},
		[onClear],
	);

	return (
		<Flex xcss={footerStyle}>
			<Box xcss={buttonStyle}>
				<Button appearance="subtle-link" onClick={handleClick}>
					{formatMessage(messages.buttonText)}
				</Button>
			</Box>
		</Flex>
	);
};

export default FooterButton;

const footerStyle = xcss({
	paddingTop: 'space.050',
	paddingBottom: 'space.050',
	justifyContent: 'start',
	borderTop: `1px solid ${token('color.border')}`,
});

const buttonStyle = xcss({
	padding: 'space.050',
	alignSelf: 'center',
	// left padding + left margin should total to 12px to match other picker types.
	marginInlineStart: 'space.100',
});
